export default __webpack_public_path__ + "static/media/dog.4247a840.svg";